// @flow
import React from 'react';
import type { CategoryData } from 'store/modules/common';
import { IconContext } from 'react-icons';
import { Link } from 'react-router-dom';
import { AiOutlineRight } from 'react-icons/ai';
import { escapeForUrl } from 'lib/common';
import './CategoryBreadcrumbs.scss';

type Props = {
  allCategories: CategoryData[],
  selectedCategory: CategoryData,
};

const CategoryBreadcrumbs = ({ allCategories, selectedCategory }: Props) => {
  let categories: CategoryData[] = [];

  const lastCategory = allCategories.find(item => item.name === selectedCategory.name);
  categories.push(lastCategory);

  if (lastCategory && lastCategory.parent) {
    const parentCategory = allCategories.find(item => item.id === lastCategory.parent);
    categories.unshift(parentCategory);

    if (parentCategory.parent) {
      const alphabetCategory = allCategories.find(item => item.id === parentCategory.parent);
      categories.unshift(alphabetCategory);
    }
  }

  const mapToBreadcrumbs = (items: CategoryData[]) => {
    if ((!items || items[0]) === undefined) return null
    return items.map((category: CategoryData, index: number) => {
      return (
        <li className="category-items" key={category.id}>
          {index > 0 && (
            <IconContext.Provider value={{ color: '#868e96', size: '11px' }}>
              <span style={{ margin: '0 4px' }}>
                <AiOutlineRight />
              </span>
            </IconContext.Provider>
          )}
          {index > 0 ? (
            <Link to={`/categories/${escapeForUrl(category.name)}`}>{category.name}</Link>
          ) : (
            <Link to={`/categories#${category.name}`}>{category.name}</Link>
          )}
        </li>
      );
    });
  }


  return (
    <div className="CategoryBreadcrumbs">
      <nav>
        <ol>{mapToBreadcrumbs(categories)}</ol>
      </nav>
    </div>
  );
};

export default CategoryBreadcrumbs;



// WEBPACK FOOTER //
// ./src/components/categories/CategoryBreadcrumbs/CategoryBreadcrumbs.js